import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DivisionsSection = () => {
  const { t } = useTranslation();

  const divisions = [
    {
      titleKey: 'divisions.records.title',
      descriptionKey: 'divisions.records.description',
      icon: 'ri-disc-line',
      link: '/records',
    },
    {
      titleKey: 'divisions.publishing.title',
      descriptionKey: 'divisions.publishing.description',
      icon: 'ri-file-music-line',
      link: '/licensing-publishing',
    },
    {
      titleKey: 'divisions.licensing.title',
      descriptionKey: 'divisions.licensing.description',
      icon: 'ri-movie-line',
      link: '/licensing-publishing',
    },
    {
      titleKey: 'divisions.management.title',
      descriptionKey: 'divisions.management.description',
      icon: 'ri-team-line',
      link: '/management',
    },
  ];

  return (
    <section className="bg-leather-dark py-16 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-20">
          <h2 className="font-display text-3xl sm:text-5xl md:text-6xl font-black text-cream mb-4 sm:mb-6 uppercase">
            {t('divisions.title')}
          </h2>
          <div className="w-16 sm:w-24 h-1 bg-orange-burnt mx-auto"></div>
        </div>

        {/* Division Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8 mb-10 sm:mb-16">
          {divisions.map((division, index) => (
            <Link
              key={index}
              to={division.link}
              className="group bg-cream/5 border-2 border-cream/20 p-6 sm:p-10 hover:border-orange-burnt transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4 sm:gap-6">
                <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-orange-burnt/10 border-2 border-orange-burnt group-hover:bg-orange-burnt transition-all duration-300 flex-shrink-0">
                  <i className={`${division.icon} text-2xl sm:text-3xl text-orange-burnt group-hover:text-cream transition-colors duration-300`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-western text-lg sm:text-2xl font-bold text-cream mb-2 sm:mb-4 group-hover:text-orange-burnt transition-colors">
                    {t(division.titleKey)}
                  </h3>
                  <p className="font-sans text-sm sm:text-base text-cream/70 leading-relaxed">
                    {t(division.descriptionKey)}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            to="/contact"
            className="inline-block bg-orange-burnt text-cream px-8 sm:px-12 py-4 sm:py-5 rounded-none font-sans text-sm sm:text-base font-bold uppercase tracking-wider hover:bg-cream hover:text-leather-dark transition-all whitespace-nowrap cursor-pointer border-2 border-orange-burnt"
          >
            {t('divisions.cta')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default DivisionsSection;
